
import React, { useState } from 'react';
import { Form, Button, Card } from 'react-bootstrap';
import { User } from 'firebase/auth';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

interface IncomeTaxCalculatorProps {
  currentUser: User | null;
}

const IncomeTaxCalculator: React.FC<IncomeTaxCalculatorProps> = ({ currentUser }) => {
  const [income, setIncome] = useState<number>(0);
  const [age, setAge] = useState<number>(0);
  const [taxRegime, setTaxRegime] = useState<'old' | 'new'>('old');
  const [tax, setTax] = useState<number | null>(null);

  const calculateTax = () => {
    let calculatedTax = 0;

    if (taxRegime === 'old') {
      if (age < 60) { // Below 60 years
        if (income <= 250000) calculatedTax = 0;
        else if (income <= 500000) calculatedTax = (income - 250000) * 0.05;
        else if (income <= 1000000) calculatedTax = 12500 + (income - 500000) * 0.20;
        else calculatedTax = 112500 + (income - 1000000) * 0.30;
      } else if (age >= 60 && age < 80) { // Senior Citizen
        if (income <= 300000) calculatedTax = 0;
        else if (income <= 500000) calculatedTax = (income - 300000) * 0.05;
        else if (income <= 1000000) calculatedTax = 10000 + (income - 500000) * 0.20;
        else calculatedTax = 110000 + (income - 1000000) * 0.30;
      } else { // Super Senior Citizen
        if (income <= 500000) calculatedTax = 0;
        else if (income <= 1000000) calculatedTax = (income - 500000) * 0.20;
        else calculatedTax = 100000 + (income - 1000000) * 0.30;
      }
    } else { // New Tax Regime
      if (income <= 300000) calculatedTax = 0;
      else if (income <= 600000) calculatedTax = (income - 300000) * 0.05;
      else if (income <= 900000) calculatedTax = 15000 + (income - 600000) * 0.10;
      else if (income <= 1200000) calculatedTax = 45000 + (income - 900000) * 0.15;
      else if (income <= 1500000) calculatedTax = 90000 + (income - 1200000) * 0.20;
      else calculatedTax = 150000 + (income - 1500000) * 0.30;
    }

    // Add 4% health and education cess
    calculatedTax += calculatedTax * 0.04;

    setTax(calculatedTax);
  };

  return (
    <Card className="p-4 shadow-sm">
      <h4 className="mb-4">Income Tax Calculator</h4>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Annual Income (₹)</Form.Label>
          <Form.Control
            type="number"
            value={income}
            onChange={(e) => setIncome(parseFloat(e.target.value))}
            placeholder="Enter annual income"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Age</Form.Label>
          <Form.Control
            type="number"
            value={age}
            onChange={(e) => setAge(parseFloat(e.target.value))}
            placeholder="Enter age"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Tax Regime</Form.Label>
          <Form.Select value={taxRegime} onChange={(e) => setTaxRegime(e.target.value as 'old' | 'new')}>
            <option value="old">Old Regime</option>
            <option value="new">New Regime</option>
          </Form.Select>
        </Form.Group>

        <Button variant="primary" onClick={calculateTax} className="w-100">
          Calculate Tax
        </Button>
        {currentUser && tax !== null && (
          <Button variant="secondary" onClick={async () => {
            try {
              await addDoc(collection(db, `users/${currentUser.uid}/savedCalculations`), {
                calculatorType: 'incomeTax',
                income,
                age,
                taxRegime,
                tax,
                timestamp: new Date(),
              });
              alert('Income Tax calculation saved!');
            } catch (e) {
              console.error('Error saving document: ', e);
              alert('Error saving calculation.');
            }
          }} className="w-100 mt-2">
            Save Calculation
          </Button>
        )}

        {tax !== null && (
          <div className="mt-4 text-center">
            <h5>Estimated Tax: ₹{tax.toFixed(2)}</h5>
          </div>
        )}
      </Form>
    </Card>
  );
};

export default IncomeTaxCalculator;
